// source: v2/types/cdr.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.loopup.ctgateway.v2.Cdr', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.Cdr = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.Cdr, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.Cdr.displayName = 'proto.loopup.ctgateway.v2.Cdr';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.Cdr.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.Cdr} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.Cdr.toObject = function(includeInstance, msg) {
  var f, obj = {
    callId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sdrSessionId: (f = msg.getSdrSessionId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    server: (f = msg.getServer()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    initiatedDateTime: (f = msg.getInitiatedDateTime()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    connectedDateTime: (f = msg.getConnectedDateTime()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    disconnectedDateTime: (f = msg.getDisconnectedDateTime()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    duration: (f = msg.getDuration()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    originatingNumber: (f = msg.getOriginatingNumber()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    terminatingNumber: (f = msg.getTerminatingNumber()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    cnam: (f = msg.getCnam()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    onNet: (f = msg.getOnNet()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    maskedCallingNumber: (f = msg.getMaskedCallingNumber()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    isDr: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
    sipAddress: (f = msg.getSipAddress()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    fileId: (f = msg.getFileId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    externalId: (f = msg.getExternalId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    callerType: (f = msg.getCallerType()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    calleeType: (f = msg.getCalleeType()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    isExported: jspb.Message.getBooleanFieldWithDefault(msg, 19, false),
    createTs: (f = msg.getCreateTs()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    lastUpdateTs: (f = msg.getLastUpdateTs()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    ingressPeer: (f = msg.getIngressPeer()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    egressPeer: (f = msg.getEgressPeer()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    inAudioSts: (f = msg.getInAudioSts()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    outAudioSts: (f = msg.getOutAudioSts()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    inRFactor: (f = msg.getInRFactor()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    egRFactor: (f = msg.getEgRFactor()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    sdrSessionStatus: (f = msg.getSdrSessionStatus()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    spare10: (f = msg.getSpare10()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    lastEventTs: (f = msg.getLastEventTs()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    carrier: (f = msg.getCarrier()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.Cdr}
 */
proto.loopup.ctgateway.v2.Cdr.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.Cdr;
  return proto.loopup.ctgateway.v2.Cdr.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.Cdr} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.Cdr}
 */
proto.loopup.ctgateway.v2.Cdr.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCallId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSdrSessionId(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setServer(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setInitiatedDateTime(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setConnectedDateTime(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDisconnectedDateTime(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setDuration(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setOriginatingNumber(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTerminatingNumber(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCnam(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setOnNet(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setMaskedCallingNumber(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDr(value);
      break;
    case 14:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSipAddress(value);
      break;
    case 15:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setFileId(value);
      break;
    case 16:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setExternalId(value);
      break;
    case 17:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCallerType(value);
      break;
    case 18:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCalleeType(value);
      break;
    case 19:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsExported(value);
      break;
    case 20:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCreateTs(value);
      break;
    case 21:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setLastUpdateTs(value);
      break;
    case 22:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setIngressPeer(value);
      break;
    case 23:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setEgressPeer(value);
      break;
    case 24:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setInAudioSts(value);
      break;
    case 25:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setOutAudioSts(value);
      break;
    case 26:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setInRFactor(value);
      break;
    case 27:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setEgRFactor(value);
      break;
    case 28:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setSdrSessionStatus(value);
      break;
    case 29:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSpare10(value);
      break;
    case 30:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setLastEventTs(value);
      break;
    case 31:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCarrier(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.Cdr.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.Cdr} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.Cdr.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCallId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSdrSessionId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getServer();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getInitiatedDateTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getConnectedDateTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDisconnectedDateTime();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDuration();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getOriginatingNumber();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTerminatingNumber();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCnam();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getOnNet();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getMaskedCallingNumber();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getIsDr();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getSipAddress();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getFileId();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getExternalId();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCallerType();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCalleeType();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getIsExported();
  if (f) {
    writer.writeBool(
      19,
      f
    );
  }
  f = message.getCreateTs();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getLastUpdateTs();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getIngressPeer();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getEgressPeer();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getInAudioSts();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getOutAudioSts();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getInRFactor();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getEgRFactor();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getSdrSessionStatus();
  if (f != null) {
    writer.writeMessage(
      28,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getSpare10();
  if (f != null) {
    writer.writeMessage(
      29,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getLastEventTs();
  if (f != null) {
    writer.writeMessage(
      30,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCarrier();
  if (f != null) {
    writer.writeMessage(
      31,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string call_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.getCallId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
 */
proto.loopup.ctgateway.v2.Cdr.prototype.setCallId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue sdr_session_id = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.getSdrSessionId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
*/
proto.loopup.ctgateway.v2.Cdr.prototype.setSdrSessionId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
 */
proto.loopup.ctgateway.v2.Cdr.prototype.clearSdrSessionId = function() {
  return this.setSdrSessionId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.hasSdrSessionId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue server = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.getServer = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
*/
proto.loopup.ctgateway.v2.Cdr.prototype.setServer = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
 */
proto.loopup.ctgateway.v2.Cdr.prototype.clearServer = function() {
  return this.setServer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.hasServer = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue initiated_date_time = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.getInitiatedDateTime = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
*/
proto.loopup.ctgateway.v2.Cdr.prototype.setInitiatedDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
 */
proto.loopup.ctgateway.v2.Cdr.prototype.clearInitiatedDateTime = function() {
  return this.setInitiatedDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.hasInitiatedDateTime = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue connected_date_time = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.getConnectedDateTime = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
*/
proto.loopup.ctgateway.v2.Cdr.prototype.setConnectedDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
 */
proto.loopup.ctgateway.v2.Cdr.prototype.clearConnectedDateTime = function() {
  return this.setConnectedDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.hasConnectedDateTime = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.StringValue disconnected_date_time = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.getDisconnectedDateTime = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
*/
proto.loopup.ctgateway.v2.Cdr.prototype.setDisconnectedDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
 */
proto.loopup.ctgateway.v2.Cdr.prototype.clearDisconnectedDateTime = function() {
  return this.setDisconnectedDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.hasDisconnectedDateTime = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Int32Value duration = 7;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.getDuration = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 7));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
*/
proto.loopup.ctgateway.v2.Cdr.prototype.setDuration = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
 */
proto.loopup.ctgateway.v2.Cdr.prototype.clearDuration = function() {
  return this.setDuration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.hasDuration = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.StringValue originating_number = 8;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.getOriginatingNumber = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 8));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
*/
proto.loopup.ctgateway.v2.Cdr.prototype.setOriginatingNumber = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
 */
proto.loopup.ctgateway.v2.Cdr.prototype.clearOriginatingNumber = function() {
  return this.setOriginatingNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.hasOriginatingNumber = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.StringValue terminating_number = 9;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.getTerminatingNumber = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 9));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
*/
proto.loopup.ctgateway.v2.Cdr.prototype.setTerminatingNumber = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
 */
proto.loopup.ctgateway.v2.Cdr.prototype.clearTerminatingNumber = function() {
  return this.setTerminatingNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.hasTerminatingNumber = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.StringValue cnam = 10;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.getCnam = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 10));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
*/
proto.loopup.ctgateway.v2.Cdr.prototype.setCnam = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
 */
proto.loopup.ctgateway.v2.Cdr.prototype.clearCnam = function() {
  return this.setCnam(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.hasCnam = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.StringValue on_net = 11;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.getOnNet = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 11));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
*/
proto.loopup.ctgateway.v2.Cdr.prototype.setOnNet = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
 */
proto.loopup.ctgateway.v2.Cdr.prototype.clearOnNet = function() {
  return this.setOnNet(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.hasOnNet = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.StringValue masked_calling_number = 12;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.getMaskedCallingNumber = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 12));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
*/
proto.loopup.ctgateway.v2.Cdr.prototype.setMaskedCallingNumber = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
 */
proto.loopup.ctgateway.v2.Cdr.prototype.clearMaskedCallingNumber = function() {
  return this.setMaskedCallingNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.hasMaskedCallingNumber = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional bool is_dr = 13;
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.getIsDr = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
 */
proto.loopup.ctgateway.v2.Cdr.prototype.setIsDr = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional google.protobuf.StringValue sip_address = 14;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.getSipAddress = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 14));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
*/
proto.loopup.ctgateway.v2.Cdr.prototype.setSipAddress = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
 */
proto.loopup.ctgateway.v2.Cdr.prototype.clearSipAddress = function() {
  return this.setSipAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.hasSipAddress = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.StringValue file_id = 15;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.getFileId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 15));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
*/
proto.loopup.ctgateway.v2.Cdr.prototype.setFileId = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
 */
proto.loopup.ctgateway.v2.Cdr.prototype.clearFileId = function() {
  return this.setFileId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.hasFileId = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional google.protobuf.StringValue external_id = 16;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.getExternalId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 16));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
*/
proto.loopup.ctgateway.v2.Cdr.prototype.setExternalId = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
 */
proto.loopup.ctgateway.v2.Cdr.prototype.clearExternalId = function() {
  return this.setExternalId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.hasExternalId = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional google.protobuf.StringValue caller_type = 17;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.getCallerType = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 17));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
*/
proto.loopup.ctgateway.v2.Cdr.prototype.setCallerType = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
 */
proto.loopup.ctgateway.v2.Cdr.prototype.clearCallerType = function() {
  return this.setCallerType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.hasCallerType = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional google.protobuf.StringValue callee_type = 18;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.getCalleeType = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 18));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
*/
proto.loopup.ctgateway.v2.Cdr.prototype.setCalleeType = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
 */
proto.loopup.ctgateway.v2.Cdr.prototype.clearCalleeType = function() {
  return this.setCalleeType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.hasCalleeType = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional bool is_exported = 19;
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.getIsExported = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 19, false));
};


/**
 * @param {boolean} value
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
 */
proto.loopup.ctgateway.v2.Cdr.prototype.setIsExported = function(value) {
  return jspb.Message.setProto3BooleanField(this, 19, value);
};


/**
 * optional google.protobuf.StringValue create_ts = 20;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.getCreateTs = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 20));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
*/
proto.loopup.ctgateway.v2.Cdr.prototype.setCreateTs = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
 */
proto.loopup.ctgateway.v2.Cdr.prototype.clearCreateTs = function() {
  return this.setCreateTs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.hasCreateTs = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional google.protobuf.StringValue last_update_ts = 21;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.getLastUpdateTs = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 21));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
*/
proto.loopup.ctgateway.v2.Cdr.prototype.setLastUpdateTs = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
 */
proto.loopup.ctgateway.v2.Cdr.prototype.clearLastUpdateTs = function() {
  return this.setLastUpdateTs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.hasLastUpdateTs = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional google.protobuf.StringValue ingress_peer = 22;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.getIngressPeer = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 22));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
*/
proto.loopup.ctgateway.v2.Cdr.prototype.setIngressPeer = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
 */
proto.loopup.ctgateway.v2.Cdr.prototype.clearIngressPeer = function() {
  return this.setIngressPeer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.hasIngressPeer = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional google.protobuf.StringValue egress_peer = 23;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.getEgressPeer = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 23));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
*/
proto.loopup.ctgateway.v2.Cdr.prototype.setEgressPeer = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
 */
proto.loopup.ctgateway.v2.Cdr.prototype.clearEgressPeer = function() {
  return this.setEgressPeer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.hasEgressPeer = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional google.protobuf.StringValue in_audio_sts = 24;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.getInAudioSts = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 24));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
*/
proto.loopup.ctgateway.v2.Cdr.prototype.setInAudioSts = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
 */
proto.loopup.ctgateway.v2.Cdr.prototype.clearInAudioSts = function() {
  return this.setInAudioSts(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.hasInAudioSts = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional google.protobuf.StringValue out_audio_sts = 25;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.getOutAudioSts = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 25));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
*/
proto.loopup.ctgateway.v2.Cdr.prototype.setOutAudioSts = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
 */
proto.loopup.ctgateway.v2.Cdr.prototype.clearOutAudioSts = function() {
  return this.setOutAudioSts(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.hasOutAudioSts = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional google.protobuf.Int32Value in_r_factor = 26;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.getInRFactor = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 26));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
*/
proto.loopup.ctgateway.v2.Cdr.prototype.setInRFactor = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
 */
proto.loopup.ctgateway.v2.Cdr.prototype.clearInRFactor = function() {
  return this.setInRFactor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.hasInRFactor = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional google.protobuf.Int32Value eg_r_factor = 27;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.getEgRFactor = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 27));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
*/
proto.loopup.ctgateway.v2.Cdr.prototype.setEgRFactor = function(value) {
  return jspb.Message.setWrapperField(this, 27, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
 */
proto.loopup.ctgateway.v2.Cdr.prototype.clearEgRFactor = function() {
  return this.setEgRFactor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.hasEgRFactor = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional google.protobuf.Int32Value sdr_session_status = 28;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.getSdrSessionStatus = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 28));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
*/
proto.loopup.ctgateway.v2.Cdr.prototype.setSdrSessionStatus = function(value) {
  return jspb.Message.setWrapperField(this, 28, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
 */
proto.loopup.ctgateway.v2.Cdr.prototype.clearSdrSessionStatus = function() {
  return this.setSdrSessionStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.hasSdrSessionStatus = function() {
  return jspb.Message.getField(this, 28) != null;
};


/**
 * optional google.protobuf.StringValue spare_10 = 29;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.getSpare10 = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 29));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
*/
proto.loopup.ctgateway.v2.Cdr.prototype.setSpare10 = function(value) {
  return jspb.Message.setWrapperField(this, 29, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
 */
proto.loopup.ctgateway.v2.Cdr.prototype.clearSpare10 = function() {
  return this.setSpare10(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.hasSpare10 = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional google.protobuf.StringValue last_event_ts = 30;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.getLastEventTs = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 30));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
*/
proto.loopup.ctgateway.v2.Cdr.prototype.setLastEventTs = function(value) {
  return jspb.Message.setWrapperField(this, 30, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
 */
proto.loopup.ctgateway.v2.Cdr.prototype.clearLastEventTs = function() {
  return this.setLastEventTs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.hasLastEventTs = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * optional google.protobuf.StringValue carrier = 31;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.getCarrier = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 31));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
*/
proto.loopup.ctgateway.v2.Cdr.prototype.setCarrier = function(value) {
  return jspb.Message.setWrapperField(this, 31, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Cdr} returns this
 */
proto.loopup.ctgateway.v2.Cdr.prototype.clearCarrier = function() {
  return this.setCarrier(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Cdr.prototype.hasCarrier = function() {
  return jspb.Message.getField(this, 31) != null;
};


goog.object.extend(exports, proto.loopup.ctgateway.v2);
